/* Adele Chérie — Personalizzazione Wizard JS
   Step navigation con validazione minima per step + copy coupon.
*/
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function init() {
    var form = $('#ac-pers-form');
    if (form) initWizard(form);
    var copyBtn = document.querySelector('[data-ac-coupon-copy]');
    if (copyBtn) initCopyCoupon(copyBtn);
  }

  function initWizard(form) {
    var steps = $$('[data-ac-step]', form);
    var dots = $$('[data-ac-dot]');
    var lines = $$('.ac-pers__progress-line');
    if (!steps.length) return;

    function goTo(stepNum) {
      stepNum = String(stepNum);
      steps.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-ac-step') === stepNum); });
      dots.forEach(function (d) {
        var n = d.getAttribute('data-ac-dot');
        d.classList.toggle('is-active', n === stepNum);
        d.classList.toggle('is-done', parseInt(n,10) < parseInt(stepNum,10));
      });
      lines.forEach(function (l, i) {
        l.classList.toggle('is-done', i < parseInt(stepNum,10) - 1);
      });
      // Scroll soft top
      var top = form.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function validateStep(currentStep) {
      // Validazione HTML5 nativa solo sui required del current step
      var currentEl = form.querySelector('[data-ac-step="' + currentStep + '"]');
      if (!currentEl) return true;
      var requiredFields = currentEl.querySelectorAll('[required]');
      var valid = true;
      requiredFields.forEach(function (f) {
        if (!f.checkValidity()) {
          valid = false;
          f.reportValidity();
        }
      });
      return valid;
    }

    // Next buttons
    $$('[data-ac-next]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = btn.closest('[data-ac-step]').getAttribute('data-ac-step');
        if (!validateStep(current)) return;
        goTo(btn.getAttribute('data-ac-next'));
      });
    });

    // Back buttons
    $$('[data-ac-back]', form).forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(btn.getAttribute('data-ac-back')); });
    });

    // Tile selection auto-advance (UX: clic tile = vai a step 2)
    $$('.ac-pers__tile input[type="radio"]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        setTimeout(function () { goTo(2); }, 300);
      });
    });
  }

  function initCopyCoupon(btn) {
    btn.addEventListener('click', function () {
      var codeEl = document.querySelector('[data-ac-coupon]');
      if (!codeEl) return;
      var code = codeEl.textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          btn.textContent = '✓ Copiato';
          btn.classList.add('is-copied');
          setTimeout(function () { btn.textContent = 'Copia'; btn.classList.remove('is-copied'); }, 2200);
        });
      } else {
        // Fallback
        var ta = document.createElement('textarea');
        ta.value = code;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); btn.textContent = '✓ Copiato'; btn.classList.add('is-copied'); }
        catch(e) {}
        document.body.removeChild(ta);
        setTimeout(function () { btn.textContent = 'Copia'; btn.classList.remove('is-copied'); }, 2200);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
